import React from 'react';
import { TEMPLATE_FORM_CONSTANTS } from '../constants';
import {
  PreviewPanel as StyledPreviewPanel,
  PreviewHeader,
  PreviewHeaderItem,
  PreviewContent,
  FormLabel,
} from '../styles';
import { processPreviewContent } from '../utils/helpers';

interface PreviewPanelProps {
  formData: any;
  variables: string[];
}

const PreviewPanel: React.FC<PreviewPanelProps> = ({ formData, variables }) => {
  return (
    <div style={{ marginTop: '24px' }}>
      <FormLabel>{TEMPLATE_FORM_CONSTANTS.LABELS.LIVE_PREVIEW}</FormLabel>
      <StyledPreviewPanel>
        <PreviewHeader>
          <PreviewHeaderItem>
            <strong>{TEMPLATE_FORM_CONSTANTS.MESSAGES.FROM_PREFIX}</strong> {formData.fromName} &lt;
            {formData.fromEmail}&gt;
          </PreviewHeaderItem>
          <PreviewHeaderItem>
            <strong>{TEMPLATE_FORM_CONSTANTS.MESSAGES.SUBJECT_PREFIX}</strong>{' '}
            {processPreviewContent(formData.subject, variables)}
          </PreviewHeaderItem>
          {formData.replyTo && (
            <PreviewHeaderItem>
              <strong>Reply-To:</strong> {formData.replyTo}
            </PreviewHeaderItem>
          )}
        </PreviewHeader>

        <PreviewContent>
          <div
            dangerouslySetInnerHTML={{
              __html: processPreviewContent(formData.htmlContent, variables),
            }}
          />
        </PreviewContent>
      </StyledPreviewPanel>
    </div>
  );
};

export default PreviewPanel;
